import React from 'react';
import { motion } from 'framer-motion';
import { ReceiptTextIcon, ScanLineIcon } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
const expenseTags = [{
  emoji: '🍽️',
  label: 'Dinner'
}, {
  emoji: '🚕',
  label: 'Taxi'
}, {
  emoji: '🍺',
  label: 'Drinks'
}, {
  emoji: '🎟️',
  label: 'Tickets'
}, {
  emoji: '🏠',
  label: 'Accommodation'
}, {
  emoji: '⛽',
  label: 'Fuel'
}, {
  emoji: '🛒',
  label: 'Big shop'
}, {
  emoji: '🎿',
  label: 'Lift pass'
}];
export function AddExpenses() {
  return <section id="features" className="bg-white py-20 lg:py-28" data-id="element-24" data-mp="19i68wd39cphr">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-25" data-mp="1nes4fhfni290">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-26" data-mp="1igqk6t6hnwvy">
          {/* Screen on the left this time */}
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative mx-auto w-full max-w-[330px] lg:max-w-[350px]" data-id="element-27" data-mp="3p6ogqt9n7g4u">
            <div aria-hidden="true" className="absolute -inset-5 rotate-2 rounded-[3rem] bg-[#FFFBF2]" data-id="element-28" data-mp="97qd3renljl1" />
            <PhoneFrame screen={screens.addExpense} shadow="xl" className="relative -rotate-2" data-id="element-29" data-mp="ix1jv7e2ic5r" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-30" data-mp="n0prtr6m39rj">
            <h2 className="mb-5 text-3xl font-black leading-[1.1] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-31" data-mp="11vvwa9q270ir">
              Someone paid for the group?
              <br data-id="element-32" data-mp="2yq0i8vz210ci" />
              <span className="mt-1 inline-block rounded-lg bg-kitty-yellow px-3 pb-1 text-kitty-dark" data-id="element-33" data-mp="2yqiomlffkuy5">
                Pot it.
              </span>
            </h2>
            <p className="mb-8 max-w-md text-lg leading-relaxed text-gray-600" data-id="element-34" data-mp="2vn32gfwkhn1p">
              Add the expense and KittyPot works out who owes whom. Choose who
              paid and split it between the people involved.
            </p>

            <ul className="mb-10 flex flex-wrap gap-2.5" data-id="element-35" data-mp="35ie9ec1qhpyw">
              {expenseTags.map(tag => <li key={tag.label} className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-[#FFFBF2] px-4 py-2 text-sm font-bold text-kitty-dark" data-id="element-36" data-mp="3elfdk771h6zx">
                  <span aria-hidden="true" data-id="element-37" data-mp="3obi31xeyc2ti">{tag.emoji}</span>
                  {tag.label}
                </li>)}
            </ul>

            {/* Receipts — supporting, not headline */}
            <div className="rounded-3xl border border-gray-100 bg-[#FFFBF2] p-7 shadow-soft" data-id="element-38" data-mp="15r5dml3z1wr">
              <div className="mb-4 flex gap-2" data-id="element-39" data-mp="3tauz98rpqm8r">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-kitty-yellow" data-id="element-40" data-mp="3tc63f9p2lw0e">
                  <ReceiptTextIcon className="h-5 w-5 text-kitty-dark" aria-hidden="true" data-id="element-41" data-mp="fr4xlemphp7a" />
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-kitty-yellow-100" data-id="element-42" data-mp="6rro4lyl10mk">
                  <ScanLineIcon className="h-5 w-5 text-kitty-yellow-700" aria-hidden="true" data-id="element-43" data-mp="bq30p4g9hp8h" />
                </span>
              </div>
              <h3 className="mb-2 text-xl font-extrabold text-kitty-dark" data-id="element-44" data-mp="1v1981yikb2q">
                Keep the receipt. Lose the argument.
              </h3>
              <p className="text-base leading-relaxed text-gray-600" data-id="element-45" data-mp="3o8rp1kyoo725">
                Snap a photo of the bill and attach it to the expense. Scanning
                can fill in the details for you, worth a quick check before you
                save.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}